import { Inject, Injectable } from "@angular/core";
import { HttpService } from "../http.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { SubmitResponse } from "../../../models";

@Injectable({
  providedIn: 'root'
})
export class SynonymsSeo extends HttpService<
  any,
  any
> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'synonyms');
  }


  exportsynonyms(language: string): Observable<Blob> {
    console.log(language, "--------service")
    return this.downloadFile(`synonyms/export?language=${language}`);
  }
  importSeoSynonyms(formData: FormData) {
    return this.create(formData, 'import?rebuild_index=true');
  }

}